import React, { useState, useEffect, useRef } from "react";
import { User } from "react-feather";
import "./SaveToListModal.css";
import { useBanner } from "../../../context/BannerContext";
import { deleteContactFilter } from "../../../services/iqApiV2";
import IOSSpinner from "../../HtmlElements/IOSSpinner";
import TextWithTooltip from "./TextWithTooltip";
import SimpleThemedButton from "../genericComponents/simpleTextField/SimpleThemedButton";

function SaveToListModal({
  show,
  onClose,
  onSave,
  title = "Contact Lists",
  buttonText = "Save Selected Contacts",
  contactLists, setContactLists,
  initialListItems
}) {
  const [deletingId, setDeletingId] = useState(null);

  const showBanner = useBanner();
  const normalize = (list) => {
    if (typeof list === "string") return { id: list, name: list };
    return list;
  };


  const [selectedLists, setSelectedLists] = useState([]);
  const [newListName, setNewListName] = useState("");
  const [isCreatingNew, setIsCreatingNew] = useState(false);

  const modalRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
        setIsCreatingNew(false);
      }
    };

    if (show) document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [show, onClose]);

  if (!show) return null;

  // Create new list
  const handleCreateList = () => {
    const trimmed = newListName.trim();
    if (!trimmed) return;

    const exists = contactLists.find((l) => l.name === trimmed);

    if (exists) {
      const isAlready = selectedLists.some((s) => s.id === exists.id);
      if (!isAlready) setSelectedLists((prev) => [...prev, exists]);
    } else {
      const newItem = { id: `temp-${Date.now()}`, name: trimmed };
      setContactLists((prev) => {
        const defaultIndex = prev.findIndex((l) => l.defaultList === true);

        
        if (defaultIndex !== -1) {
          return [
            ...prev.slice(0, defaultIndex + 1),
            newItem,
            ...prev.slice(defaultIndex + 1)
          ];
        }

        
        return [newItem, ...prev];
      });

      setSelectedLists((prev) => [...prev, newItem]);
    }

    setNewListName("");
    setIsCreatingNew(false);
  };

  // Toggle selection
  const toggleSelection = (listObj) => {
    setSelectedLists((prev) => {
      const exists = prev.some((s) => s.id === listObj.id);
      if (exists) return prev.filter((s) => s.id !== listObj.id);
      return [...prev, listObj];
    });
  };


  // Save lists
  const handleSave = async() => {
    onSave(selectedLists);
    await onClose();
    setIsCreatingNew(false);
  };

  return (
    <div className="dropdown-panel_sss" ref={modalRef}>
      <h2 className="dropdown-title_sss">{title}</h2>

      <ul className="contact-lists_sss">
        {contactLists.map((list) => {
          const isSelected = selectedLists.some((s) => s.id === list.id);
          const isLongName = list.name.length > 24;
          if(!list.id && list?.name){
            list.id = list.name
          }
          
          return (
            <li
              key={list.id}
              className={`contact-list-item_sss ${isSelected ? "selected_sss" : ""}`}
              onClick={() => toggleSelection(list)}
            >
              {isLongName ? (
          <TextWithTooltip text={list.name} className="contact-list-item_text_sss"/>
              ) : (
                <span className="contact-list-item_text_sss">{list.name}</span>
              )}
              <User size={18} className="contact-icon_sss" />
            </li>
          );
        })}
      </ul>

      <div className="modal-footer_sss">
        {!isCreatingNew ? (
          <div className="footer-row_sss">
            <span className="new-list-text_sss" onClick={() => setIsCreatingNew(true)}>
              + New List
            </span>

            {selectedLists.length > 0 && (
              <SimpleThemedButton
                buttonText={buttonText}
                onBtnClick={()=>handleSave()}
              />
            )}
          </div>
        ) : (
          <div className="new-list-input-row_sss">
            <input
              type="text"
              placeholder="Enter new list name"
              value={newListName}
              onChange={(e) => setNewListName(e.target.value)}
              className="modal-input_sss"
            />

            <div className="footer-row_sss">
              <button className="modal-create-btn_sss" onClick={handleCreateList}>
                Create
              </button>

              {selectedLists.length > 0 && (
                <SimpleThemedButton
                  buttonText={buttonText}
                  onBtnClick={()=>handleSave()}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SaveToListModal;
